import { Box, Card, Stack, Typography } from "@mui/material";
import { delftBlue } from "@/theme/colors";

const FormStatsCards = ({ stats }) => {
  const { total = 8, activitiesForms = 5, otherForms = 3 } = stats || {};

  return (
    <Stack
      direction={{ xs: "column", sm: "row" }}
      spacing={{ xs: 1.5, sm: 2 }}
      sx={{
        alignSelf: "stretch",
      }}
    >
      <Card
        sx={{
          flex: "1 1 0",
          minWidth: 0,
          width: "100%",
          paddingTop: { xs: 0.75, sm: 1 },
          paddingBottom: { xs: 0.75, sm: 1 },
          background: "white",
          borderRadius: 2,
          outline: `1px ${delftBlue[100]} solid`,
          outlineOffset: "-1px",
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          justifyContent: "space-between",
          alignItems: { xs: "flex-start", sm: "center" },
          gap: { xs: 1, sm: 0 },
          overflow: "visible",
          position: "relative",
        }}
      >
        <Box
          sx={{
            flex: { xs: "0 0 auto", sm: "1 1 0" },
            width: { xs: "100%", sm: "auto" },
            paddingLeft: { xs: 2, sm: 2.5, md: 3 },
            paddingRight: { xs: 2, sm: 2.5, md: 3 },
            paddingTop: { xs: 0.75, sm: 1 },
            paddingBottom: { xs: 0.75, sm: 1 },
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            gap: 0.75,
          }}
        >
          <Typography
            sx={{
              color: delftBlue[500],
              fontSize: { xs: 14, sm: 15, md: 16 },
              fontFamily: "Audiowide, sans-serif",
              fontWeight: 400,
              display: "block",
              visibility: "visible",
            }}
          >
            Total Forms
          </Typography>
        </Box>
        <Box
          sx={{
            flex: { xs: "0 0 auto", sm: "1 1 0" },
            width: { xs: "100%", sm: "auto" },
            paddingLeft: { xs: 2, sm: 2.5, md: 3 },
            paddingRight: { xs: 2, sm: 2.5, md: 3 },
            paddingTop: { xs: 0, sm: 1 },
            paddingBottom: { xs: 0.75, sm: 1 },
            display: "flex",
            justifyContent: { xs: "flex-start", sm: "flex-end" },
            alignItems: "center",
            gap: 1,
          }}
        >
          <Typography
            sx={{
              color: delftBlue[500],
              fontSize: { xs: 20, sm: 18, md: 16 },
              fontFamily: "Montserrat, sans-serif",
              fontWeight: 700,
              display: "block",
              visibility: "visible",
            }}
          >
            {total !== undefined && total !== null ? total : "N/A"}
          </Typography>
        </Box>
      </Card>

      <Card
        sx={{
          flex: "1 1 0",
          minWidth: 0,
          width: "100%",
          paddingTop: { xs: 0.75, sm: 1 },
          paddingBottom: { xs: 0.75, sm: 1 },
          background: "white",
          borderRadius: 2,
          outline: `1px ${delftBlue[100]} solid`,
          outlineOffset: "-1px",
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          justifyContent: "space-between",
          alignItems: { xs: "flex-start", sm: "center" },
          gap: { xs: 1, sm: 0 },
          overflow: "visible",
          position: "relative",
        }}
      >
        <Box
          sx={{
            flex: { xs: "0 0 auto", sm: "1 1 0" },
            width: { xs: "100%", sm: "auto" },
            paddingLeft: { xs: 2, sm: 2.5, md: 3 },
            paddingRight: { xs: 2, sm: 2.5, md: 3 },
            paddingTop: { xs: 0.75, sm: 1 },
            paddingBottom: { xs: 0.75, sm: 1 },
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            gap: 0.75,
          }}
        >
          <Typography
            sx={{
              color: delftBlue[500],
              fontSize: { xs: 14, sm: 15, md: 16 },
              fontFamily: "Audiowide, sans-serif",
              fontWeight: 400,
              display: "block",
              visibility: "visible",
            }}
          >
            Activities Forms
          </Typography>
        </Box>
        <Box
          sx={{
            flex: { xs: "0 0 auto", sm: "1 1 0" },
            width: { xs: "100%", sm: "auto" },
            paddingLeft: { xs: 2, sm: 2.5, md: 3 },
            paddingRight: { xs: 2, sm: 2.5, md: 3 },
            paddingTop: { xs: 0, sm: 1 },
            paddingBottom: { xs: 0.75, sm: 1 },
            display: "flex",
            justifyContent: { xs: "flex-start", sm: "flex-end" },
            alignItems: "center",
            gap: 1,
          }}
        >
          <Typography
            sx={{
              color: delftBlue[500],
              fontSize: { xs: 20, sm: 18, md: 16 },
              fontFamily: "Montserrat, sans-serif",
              fontWeight: 700,
              display: "block",
              visibility: "visible",
            }}
          >
            {activitiesForms !== undefined && activitiesForms !== null ? activitiesForms : "N/A"}
          </Typography>
        </Box>
      </Card>

      <Card
        sx={{
          flex: "1 1 0",
          minWidth: 0,
          width: "100%",
          paddingTop: { xs: 0.75, sm: 1 },
          paddingBottom: { xs: 0.75, sm: 1 },
          background: "white",
          borderRadius: 2,
          outline: `1px ${delftBlue[100]} solid`,
          outlineOffset: "-1px",
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          justifyContent: "space-between",
          alignItems: { xs: "flex-start", sm: "center" },
          gap: { xs: 1, sm: 0 },
          overflow: "visible",
          position: "relative",
        }}
      >
        <Box
          sx={{
            flex: { xs: "0 0 auto", sm: "1 1 0" },
            width: { xs: "100%", sm: "auto" },
            paddingLeft: { xs: 2, sm: 2.5, md: 3 },
            paddingRight: { xs: 2, sm: 2.5, md: 3 },
            paddingTop: { xs: 0.75, sm: 1 },
            paddingBottom: { xs: 0.75, sm: 1 },
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            gap: 0.75,
          }}
        >
          <Typography
            sx={{
              color: delftBlue[500],
              fontSize: { xs: 14, sm: 15, md: 16 },
              fontFamily: "Audiowide, sans-serif",
              fontWeight: 400,
              display: "block",
              visibility: "visible",
            }}
          >
            Other Forms
          </Typography>
        </Box>
        <Box
          sx={{
            flex: { xs: "0 0 auto", sm: "1 1 0" },
            width: { xs: "100%", sm: "auto" },
            paddingLeft: { xs: 2, sm: 2.5, md: 3 },
            paddingRight: { xs: 2, sm: 2.5, md: 3 },
            paddingTop: { xs: 0, sm: 1 },
            paddingBottom: { xs: 0.75, sm: 1 },
            display: "flex",
            justifyContent: { xs: "flex-start", sm: "flex-end" },
            alignItems: "center",
            gap: 1,
          }}
        >
          <Typography
            sx={{
              color: delftBlue[500],
              fontSize: { xs: 20, sm: 18, md: 16 },
              fontFamily: "Montserrat, sans-serif",
              fontWeight: 700,
              display: "block",
              visibility: "visible",
            }}
          >
            {otherForms !== undefined && otherForms !== null ? otherForms : "N/A"}
          </Typography>
        </Box>
      </Card>
    </Stack>
  );
};

export default FormStatsCards;



